import { useState } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";
import { useApi, errMsg, ago } from "@/lib/api";

export const SuggestedUpdate = ({ m, r, onDone }) => {
  const api = useApi();
  const [busy, setBusy] = useState("");
  const su = r.suggested_update;
  if (!su) return null;
  const id = `${m.id}-${r.number}`;
  const act = async (action) => {
    setBusy(action);
    try {
      await api("post", `/admin/meetings/${m.id}/races/${r.number}/suggested-update/${action}`);
      toast.success(action === "apply" ? `${m.track} R${r.number} tips updated` : "Suggestion dismissed");
      onDone();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy("");
  };
  return (
    <div className="mt-3 rounded-xl border border-amber-500/40 bg-amber-500/5 p-3 space-y-2" data-testid={`bot-update-${id}`}>
      <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-amber-300"><RefreshCw className="w-3.5 h-3.5" />Suggested update with live prices</p>
      <ul className="text-sm text-slate-200 space-y-0.5" data-testid={`bot-update-changes-${id}`}>{su.changes.map((c) => <li key={c}>{c}</li>)}</ul>
      <ul className="text-xs text-slate-400 space-y-0.5">
        {su.selections.map((s) => <li key={s.number}>{s.role}: {s.number}. {s.horse}{s.odds ? ` · $${Number(s.odds).toFixed(2)}` : ""}</li>)}
      </ul>
      {su.no_roughie_reason && <p className="text-xs text-fuchsia-300">{su.no_roughie_reason}</p>}
      <div className="flex flex-wrap gap-2 pt-1">
        <button data-testid={`bot-update-apply-${id}`} disabled={!!busy} onClick={() => act("apply")} className="px-4 py-1.5 rounded-full bg-emerald-600 hover:bg-emerald-500 text-xs font-semibold disabled:opacity-50">{busy === "apply" ? "Updating…" : "Approve update"}</button>
        <button data-testid={`bot-update-dismiss-${id}`} disabled={!!busy} onClick={() => act("dismiss")} className="px-3 py-1.5 rounded-full border border-white/10 text-xs text-slate-300 hover:text-white disabled:opacity-50">Keep current tips</button>
        <span className="text-[10px] text-slate-500 self-center">Found {ago(su.at)}</span>
      </div>
    </div>
  );
};
